import { $authHost } from '.'
import { Update } from '../helpers/types/update'

export const fetchUpdates = async (id: number) => {
	const { data } = await $authHost.get('/updates/' + id)
	return data as Update[]
}
